import { render, staticRenderFns } from "./InvoiceOrderDetail.vue?vue&type=template&id=d23f8c70&scoped=true&"
import script from "./InvoiceOrderDetail.vue?vue&type=script&lang=js&"
export * from "./InvoiceOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23f8c70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VDivider,VIcon})
